export interface DownloadBibliographyMarcTooliRequest {
  marcNo: string
  materialFormat: string
}

export function DownloadBibliographyMarcTooliRequestToJSON(
  value: DownloadBibliographyMarcTooliRequest
): any {
  return {
    marc_no: value.marcNo !== '' ? value.marcNo : undefined,
    material_format:
      value.materialFormat !== '' ? value.materialFormat : undefined
  }
}
